import React, { useState, useEffect } from "react";
import axios from "axios";
import HeaderOne from "../../../HeaderOne";
import Breadcrumb from "../../../Breadcrumb";
import FooterOne from "../../../FooterOne";
import "./Profile.scss";
import Swal from 'sweetalert2';

const API_URL = process.env.REACT_APP_API_URL;

const Profile = () => {
  const token = localStorage.getItem("authToken");

  const [loading, setLoading] = useState(true);

  const [profileData, setProfileData] = useState({
    first_name: "",
    last_name: "",
    username: "",
    email: "",
    mobileNumber: "",
    type: "",
    image: "",
  });

  const [editingField, setEditingField] = useState(null);
  const [tempValue, setTempValue] = useState("");

  const [selectedImage, setSelectedImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [uploading, setUploading] = useState(false);
  
  // ====== profile fetch ========
  const fetchProfile = async () => {
    try {
      const res = await axios.get(`${API_URL}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const user = res.data.user;

      setProfileData({
        first_name: user.first_name || "",
        last_name: user.last_name || "",
        username: user.username || "",
        email: user.email || "",
        mobileNumber: user.phone || "",
        type: user.type || "",
        image: user.image || "",
      });

      // console.log(user);

      setLoading(false);
    } catch (err) {
      console.error("Profile Fetch Error:", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);


  const uploadToS3 = async (file) => {
  if (!file) return null;

  const formData = new FormData();
  formData.append("file", file);

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/upload/single`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return res.data.fileUrl; // S3 URL
  } catch (err) {
    console.error("S3 Upload error:", err);
    return null;
  }
};

  const handleImageSelect = (e) => {
  const file = e.target.files[0];
  setSelectedImage(file);

  if (file) {
    const reader = new FileReader();
    reader.onloadend = () => setPreviewImage(reader.result);
    reader.readAsDataURL(file);
  }
};

  const handleImageUpload = async () => {
  if (!selectedImage) return;

  setUploading(true);

  // Upload to S3
  const uploadedURL = await uploadToS3(selectedImage);

  if (!uploadedURL) {
    Swal.fire("Image upload failed!");
    setUploading(false);
    return;
  }

  try {
    const id = localStorage.getItem("userId")
    await axios.put(
      `${API_URL}/auth/updateUser/${id}`,
      { image: uploadedURL }, 
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setProfileData((prev) => ({ ...prev, image: uploadedURL }));
    setPreviewImage(null);
    setSelectedImage(null);
    Swal.fire("Profile photo updated!");
  } catch (error) {
    console.error("Photo update error:", error);
    Swal.fire("Failed to update photo.");
  }

  setUploading(false);
};


  // ====== save data ==========
  const handleSave = async (field) => {
    try {
      const payload = {};
      const id = localStorage.getItem("userId")
      // console.log(id);
      if (field === "mobileNumber") payload.phone = tempValue;
      else payload[field] = tempValue;

      await axios.put(`${API_URL}/auth/updateUser/${id}`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setProfileData((prev) => ({
        ...prev,
        [field]: tempValue,
      }));
    } catch (error) {
      console.error("Update Error:", error);
    }

    setEditingField(null);
    setTempValue("");
  };

  const handleEdit = (field) => {
    setEditingField(field);
    setTempValue(profileData[field]);
  };

  const handleCancel = () => {
    setEditingField(null);
    setTempValue("");
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/account";
  };

  if (loading) return <div style={{ padding: 50 }}>Loading...</div>;

  return (
    <>
      <HeaderOne />
      <Breadcrumb />

      <div className="profile-page">
        <div className="profile-container">
          <div className="profile-photo-card">
            <img
              src={previewImage || profileData.image}
              alt="Profile"
              className="profile-photo"
            />

            <label className="change-photo-btn">
              Change Photo
              <input type="file" accept="image/*" onChange={handleImageSelect} hidden />
            </label>

            {selectedImage && (
              <button
                className="save-photo-btn"
                onClick={handleImageUpload}
                disabled={uploading}
              >
                {uploading ? "Uploading..." : "Save Photo"}
              </button>
            )}
          </div>

          <div className="profile-card">
            <ProfileField
              label="First Name"
              value={profileData.first_name}
              editing={editingField === "first_name"}
              onEdit={() => handleEdit("first_name")}
              onSave={() => handleSave("first_name")}
              tempValue={tempValue}
              setTempValue={setTempValue}
              onCancel={handleCancel}
            />

            <ProfileField
              label="Last Name"
              value={profileData.last_name}
              editing={editingField === "last_name"}
              onEdit={() => handleEdit("last_name")}
              onSave={() => handleSave("last_name")}
              tempValue={tempValue}
              setTempValue={setTempValue}
              onCancel={handleCancel}
            />

            <ProfileField
              label="Username"
              value={"@" + profileData.username}
              editing={editingField === "username"}
              onEdit={() => handleEdit("username")}
              onSave={() => handleSave("username")}
              tempValue={tempValue}
              setTempValue={setTempValue}
              onCancel={handleCancel}
            />

            <ProfileField
              label="Phone Number"
              value={profileData.mobileNumber || "Not Added"}
              editing={editingField === "mobileNumber"}
              onEdit={() => handleEdit("mobileNumber")}
              onSave={() => handleSave("mobileNumber")}
              tempValue={tempValue}
              setTempValue={setTempValue}
              onCancel={handleCancel}
            />

            {/* <ProfileField
              label="Email"
              value={profileData.email}
              editing={editingField === "email"}
              onEdit={() => handleEdit("email")}
              onSave={() => handleSave("email")}
              tempValue={tempValue}
              setTempValue={setTempValue}
              onCancel={handleCancel}
            /> */}

             <div className="profile-field">
              <h3 className="field-label">Email</h3>
              <p className="field-value">{profileData.email}</p>
            </div>


            <div className="profile-field">
              <h3 className="field-label">Account Type</h3>
              <p className="field-value">{profileData.type}</p>
            </div>

            <div className="profile-field">
              <button className="logout-btn" onClick={handleLogout}>
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>

      <FooterOne />
    </>
  );
};

export default Profile;

const ProfileField = ({
  label,
  value,
  editing,
  onEdit,
  onSave,
  tempValue,
  setTempValue,
  onCancel,
}) => {
  return (
    <div className="profile-field">
      <div className="field-content">
        <div className="field-info">
          <h3 className="field-label">{label}</h3>

          {editing ? (
            <div className="edit-input-group">
              <input
                type="text"
                value={tempValue}
                onChange={(e) => setTempValue(e.target.value)}
                className="edit-input"
              />
              <div className="edit-actions">
                <button onClick={onSave} className="save-btn">
                  Save
                </button>
                <button onClick={onCancel} className="cancel-btn">
                  Cancel
                </button>
              </div>
            </div>
          ) : (
            <p className="field-value">{value}</p>
          )}
        </div>

        {!editing && <button className="edit-btn" onClick={onEdit}>Edit</button>}
      </div>
    </div>
  );
};
